export const isPreviewHost = (): boolean => {
  if (typeof window === "undefined") return false;
  const h = window.location.hostname;
  return h.includes("id-preview--") || h.includes("lovableproject.com");
};

export const isNetworkError = (err: unknown): boolean => {
  if (!err) return false;
  const msg =
    typeof err === "string"
      ? err
      : (err as { message?: string })?.message ?? "";
  const m = msg.toLowerCase();
  return (
    m.includes("failed to fetch") ||
    m.includes("networkerror") ||
    m.includes("network error") ||
    m.includes("load failed") ||
    m.includes("fetch failed")
  );
};

export const friendlyAuthError = (err: unknown): string => {
  const msg =
    typeof err === "string"
      ? err
      : (err as { message?: string })?.message ?? "";
  const m = msg.toLowerCase();
  if (m.includes("invalid login credentials")) return "E-mail ou senha incorretos.";
  if (m.includes("email not confirmed")) return "Confirme seu e-mail antes de entrar.";
  if (isNetworkError(err)) return "Falha de conexão. Tente novamente em instantes.";
  return "Não foi possível concluir a operação. Tente novamente.";
};

/**
 * Returns true if the toast should be SUPPRESSED (network error in preview).
 * Use to gate raw error toasts in public/home flows.
 */
export const shouldSuppressNetworkToast = (err: unknown): boolean => {
  return isNetworkError(err) && isPreviewHost();
};